import { Injectable } from '@angular/core';

import { Task } from '../../../../data/todo/domain/task';
import { ToDoCommands } from '../../../../data/todo/domain/todo_commands';

@Injectable()
export class TaskModalFacade {
  constructor(private toDoCommands: ToDoCommands) {
    // nada
  }

  async save(task: Task): Promise<Task> {
    return this.toDoCommands.saveTask(task);
  }
}
